import { Controller } from "@hotwired/stimulus"

// The plan line form: switches between supplier and free line, borrows the
// supplier's name as description, and previews net, VAT and gross as you type.
export default class extends Controller {
  static targets = ["kind", "supplierField", "supplier", "description", "quantity", "unitCost", "vatRate", "net", "vat", "gross"]

  connect() {
    this.toggleKind()
    this.preview()
  }

  toggleKind() {
    const kind = this.kindTargets.find((r) => r.checked)?.value || "free"
    this.supplierFieldTarget.hidden = kind !== "supplier"
    if (kind !== "supplier") this.supplierTarget.value = ""
  }

  supplierChanged() {
    const option = this.supplierTarget.selectedOptions[0]
    if (option && option.value && !this.descriptionTarget.value.trim()) {
      this.descriptionTarget.value = option.textContent.trim()
    }

    const rate = option?.dataset.dailyRate
    const currentCost = parseFloat(this.unitCostTarget.value)
    if (rate && (this.unitCostTarget.value.trim() === "" || !currentCost)) {
      this.unitCostTarget.value = rate
      this.preview()
    }
  }

  preview() {
    const quantity = parseFloat(this.quantityTarget.value) || 0
    const unitCost = parseFloat(this.unitCostTarget.value) || 0
    const vatRate = parseFloat(this.vatRateTarget.value) || 0
    const net = Math.round(quantity * unitCost * 100) / 100
    const vat = Math.round(net * vatRate) / 100
    this.netTarget.textContent = this.euro(net)
    this.vatTarget.textContent = this.euro(vat)
    this.grossTarget.textContent = this.euro(net + vat)
  }

  euro(value) {
    return value.toLocaleString("it-IT", { style: "currency", currency: "EUR" })
  }
}
